// 工单审核通过
<template>
<van-list
  v-model="loading"
  :finished="finished"
  :finished-text="finishedText"
  :immediate-check="false"
  @load="onLoad"
  class="wrapper"
  >
  <div class="box">
    <div class="main">
      <div class="statistics line_bottom">
        <div class="title">{{taskInfoData.taskName}}</div>
        <div class="completionDate" v-show="taskInfoData.endTime">目标完成日期：{{taskInfoData.endTime|filtTime1}}</div>
        <div class="approvalStatus">
          <div class="mode2">审核通过</div>
          <div class="seeTheExamineText" >
            <span v-if="taskInfoData.auditReason"  @click="handleSeeExamineText">查看审核意见</span>
            <span v-if="!taskInfoData.auditReason">⽆审核意⻅</span>
            <div class="theExamineTextIcom" v-if="taskInfoData.auditReason">
              <img
                src="../../../../assets/image/ic_xl@2x.png"
                v-show="isShowTheExamineText"
              />
              <img
                src="../../../../assets/image/ic_xl@2x.png"
                v-show="!isShowTheExamineText"
                style="transform: rotate(180deg);"
              />
            </div>
          </div>
        </div>
        <div v-if="taskInfoData.auditReason" class="theExamineTextBox" :style="{height:isShowTheExamineText?'auto':'0px',overflow:!isShowTheExamineText?'hidden':'visible',}">
          <div id="memoTextBox">
            <p id="memoText" class="theExamineText" :class="{'showMore': !isShowAllExamineText ,'showSome': isShowAllExamineText}">{{taskInfoData.auditReason}}</p>
          </div>
          <div class="showAllExamineTextBtn" @click="handleClickAllExamineTex" v-show="isNeedSecBtn">
            <span v-show="!isShowAllExamineText">展开</span>
            <span v-show="isShowAllExamineText">收起</span>
            <div class="showAllExamineTextIcon">
              <img
                v-show="!isShowAllExamineText"
                src="../../../../assets/image/ic_jiantou_down.png"
                alt
              />
              <img
                v-show="isShowAllExamineText"
                src="../../../../assets/image/ic_jiantou_up.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="dataListBox">
        <div class="dataListNav" >
          <div
          v-for="(item, index) in dataListNavList"
            :key="index"
            class="dataListNavItem"
            v-show='item.isShow'
            :class="{'active':isDlNavItem === index}"
            @click="handleDlNavItemActive(index)"
          >{{item.name}}</div>
        </div>
        <div class="choiceIndustryBox" v-if="isDlNavItem === 0">
          <div class="choiceIndustryBtn" @click="handleChoiceIndustryPop">
            <span class="choiceIndustryBtnText">{{industryText.text}}</span>
            <div class="choiceIndustryBtnIcon">
              <img src="../../../../assets/image/xiala.png" />
            </div>
          </div>
          <div class="allListCounts">共{{workOrderPageTotal}}个工单</div>
        </div>
        <!-- 评分对象列表 -->
        <div class="scoreObjectList" v-if="isDlNavItem === 0">

      <workOrderPieChart :pieData='pieData' :total='total' v-if='taskInfoData.taskStatus>10'></workOrderPieChart>

            <div class="scoreObjectListItem" :class="{scoreObjectListItemList: (index+ 1) === workOrderPageList.length}" v-for="(item,index) in workOrderPageList" :key="index">
              <p class="scoreObjectId">工单ID:{{item.workOrderId}}</p>
              <div class="scoreObjectNameBox" @click="toPageDetailOrders(item)">
                <div class="scoreObjectName">{{item.enterpriseName}}</div>
                <div class="scoreObjectTo">
                  <span>{{item.result}}</span>
                  <img src="../../../../assets/image/t-right.png" />
                </div>
              </div>
              <div class="scoreObjectBages">
                <div class="locationBage line_border_blue">{{item.regionName}}</div>
                <div class="industryBage line_border_green">{{item.industryCategoryName}}</div>
              </div>
            </div>

        </div>
        <!-- 任务信息列表 -->
        <div class="taskDetailList" v-if="isDlNavItem === 1">
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">创建时间:</div>
            <p v-show='taskInfoData.createTime'>{{taskInfoData.createTime |filtTime}}</p>
          </div>
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">受委托方:</div>
            <p>{{taskInfoData.unitName}}</p>
          </div>
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">涉及行业类别:</div>
            <p>{{taskInfoData.industryCategory}}</p>
          </div>
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">任务描述:</div>
            <p>{{taskInfoData.memo}}</p>
          </div>
        </div>
        <!-- 操作记录列表 -->
        <div class="operationRecordList" v-if="isDlNavItem === 2">
          <div class="operationListItem" v-for="(item, index) in operationRecordList" :key="index">
            <h5 class="operationTitle">{{item.typeName}}</h5>
            <div class="operationTime" v-show='item.optTime'>{{item.optTime | filtTime}}</div>
            <div class="operaterBox">{{'操作人：' + item.optName}}</div>
            <p class="operationDetail">{{item.memo}}</p>
            <span class="timePoint"></span>
          </div>
        </div>
      </div>
      <common-picker
        ref="isShowIndustryPop"
        :typeList="industryList"
        :cols="cols1"
        @getTypeValue="getTypeValue"
      ></common-picker>
      <!-- <transition name="fade">
        <div
          class="examineDetailTipsBox"
          transition="fade"
          v-show="examineDetailTips"
          @click="handleTest"
        >
          <img src="../../../../assets/image/icon_ts_tg.png" v-if="tipsIcon" />
          <img src="../../../../assets/image/icon_ts_gx.png" v-if="!tipsIcon" />
          <p>{{tipsIcon?'审核通过':'失败示例'}}</p>
        </div>
      </transition> -->
    </div>
  </div>
  </van-list>
</template>
<script>
    import commonPicker from '../../../../components/base/commonPicker';
    import api from '../../../../service/modules/integrity';
    import workOrderPieChart from '../../../../components/workOrderPieChart';
    import apimessage from '../../../../service/modules/message'
    export default {
        components: {
            commonPicker,
            workOrderPieChart
        },
        data () {
            return {
                finishedText: '',
                loading: false,
                finished: false,
                pageIndex: 1,
                pageSize: 10,
                active: '',
                // 审核意见文本
                theExamineText: '1',
                // 是否需要二级展开按钮
                isNeedSecBtn: false,
                // 是否查看审核意见文本
                isShowTheExamineText: true,
                // 展示全部审查文本
                isShowAllExamineText: false,
                // 是否通过审核
                throughExamine: false,
                isDlNavItem: 0,
                dataListNavList: [
                    { name: '评分对象', isShow: true },
                    { name: '任务信息', isShow: true },
                    { name: '操作记录', isShow: true }
                ],
                // 行业标签
                industryText: { text: '全部行业', type: '' },
                // 选择行业弹窗List
                industryList: [],
                cols1: 1,
                meno: '', // 审核意见
                // 审核Picker弹出层
                isShowExaminePicker: false,
                isThroughExamine: false,
                isNotThroughExamine: false,
                checked: false,
                throughExamineText: '',
                // 操作记录按钮测试列表
                operationRecordList: [],
                // 提交按钮提交完的tip状态
                examineDetailTips: false,
                tipsIcon: true,
                taskId: '',
                parmId: '', // 审核通过完成后过来的id
                workOrderPageList: [], // 评分对象列表
                workOrderPageTotal: '', // 评分列表数量
                taskInfoData: {}, // 任务信息
                memo: '',
                pieData: [], // 饼状图数据
                total: 0,
                industryCategory: '' // 行业参数
            };
        },
        created () {
            this.taskId = this.$route.query.taskId;
            this.id = this.$route.query.id;
            this.handleList();
            this.getworkOrderPage();
            this.getIndustryCategory();
            this.getratingTaskLog();
            this.getTaskProgress(); // 饼状图数据
        },
        mounted () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)

            this.$nextTick(() => {
                this.listenTheMemo();
            })
        },
        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            onLoad () {
                this.pageIndex++
                this.getworkOrderPage()
            },
            // 进入页面监听文本高度
            listenTheMemo () {
                if (document.querySelector('#memoText')) {
                    let height = document.getElementById('memoText').offsetHeight;
                    let lineHeight = parseInt(getComputedStyle(document.querySelector('#memoText'), null).lineHeight);
                    if (height > lineHeight * 4) {
                        this.isNeedSecBtn = true;
                        this.isShowAllExamineText = false;
                    } else {
                        this.isNeedSecBtn = false;
                        this.isShowAllExamineText = true;
                    }
                }
            },
            // 任务信息
            handleList () {
                let parm = {
                    taskId: this.taskId
                };
                api.taskInfo(parm).then(res => {
                    if (res.ret === 0) {
                        res.data.industryCategory = res.data.industryCategory.substr(1);
                        res.data.industryCategory = res.data.industryCategory.substr(
                            0,
                            res.data.industryCategory.length - 1
                        );
                        this.taskInfoData = res.data;
                        // console.log(this.taskInfoData)
                        this.memo = this.taskInfoData.memo;
                    }
                });
            },
            // 获取饼状图的数据
            getTaskProgress () {
                let parm = {
                    taskId: this.taskId,
                    industryCategory: this.industryCategory
                };
                api.gradeProgress(parm).then(res => {
                    if (res.ret === 0) {
                        if (res.data) {
                            this.total = res.data.total
                            let waitAllotCountRadito = 0
                            let waitScoreCountRadito = 0
                            let signCountRadito = 0
                            let waitAgainCountRadito = 0
                            let finishCountRadito = 0
                            let closeCountRadito = 0
                            let pendingAuditCountRadito = 0
                            waitAllotCountRadito = Math.round((res.data.waitAllotCount / res.data.total) * 100)
                            waitScoreCountRadito = Math.round((res.data.waitScoreCount / res.data.total) * 100)
                            signCountRadito = Math.round((res.data.signCount / res.data.total) * 100)
                            waitAgainCountRadito = Math.round((res.data.waitAgainCount / res.data.total) * 100)
                            finishCountRadito = Math.round((res.data.finishCount / res.data.total) * 100)
                            closeCountRadito = Math.round((res.data.closeCount / res.data.total) * 100)
                            pendingAuditCountRadito = Math.round((res.data.pendingAuditCount / res.data.total) * 100)
                            let arr = [
                                {
                                    name: '待审核',
                                    value: res.data.pendingAuditCount === 0 ? null : res.data.pendingAuditCount,
                                    radito: pendingAuditCountRadito
                                },
                                {
                                    name: '待分配',
                                    value: res.data.waitAllotCount === 0 ? null : res.data.waitAllotCount,
                                    radito: waitAllotCountRadito
                                },
                                {
                                    name: '待评分',
                                    value: res.data.waitScoreCount === 0 ? null : res.data.waitScoreCount,
                                    radito: waitScoreCountRadito
                                },
                                {
                                    name: '已签到',
                                    value: res.data.signCount === 0 ? null : res.data.signCount,
                                    radito: signCountRadito
                                },
                                {
                                    name: '已完成',
                                    value: res.data.finishCount === 0 ? null : res.data.finishCount,
                                    radito: finishCountRadito
                                },
                                {
                                    name: '已关闭',
                                    value: res.data.closeCount === 0 ? null : res.data.closeCount,
                                    radito: closeCountRadito
                                },
                                {
                                    name: '待二次确认',
                                    value: res.data.waitAgainCount === 0 ? null : res.data.waitAgainCount,
                                    radito: waitAgainCountRadito
                                }
                            ];
                            this.pieData = arr
                        }
                    }
                });
            },
            // 评分任务详情
            getworkOrderPage () {
                let parm = {
                    taskId: this.taskId,
                    industryCategory:　this.industryCategory,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                };
                api.workOrderPage(parm).then(res => {
                    if (res.ret === 0) {
                        let arr = res.data.list
                        if (arr.length > 0) {
                            this.workOrderPageList = this.workOrderPageList.concat(arr)
                            if (arr.length < 10) {
                                this.finished = true
                                this.finishedText = '没有更多了'
                            }
                        } else {
                            this.finished = true
                            this.finishedText = '没有更多了'
                        }
                        this.loading = false
                        // this.workOrderPageList = res.data.list;
                        this.workOrderPageTotal = res.data.pageination.total;
                    }
                });
            },
            // 获取操作记录
            getratingTaskLog () {
                api.ratingTaskLog({ taskId: this.taskId }).then(res => {
                    if (res.ret === 0) {
                        this.operationRecordList = res.data;

                        if (this.operationRecordList.length > 0) {
                            this.dataListNavList[2].isShow = true;
                        } else {
                            this.dataListNavList[2].isShow = false;
                        }
                    }
                });
            },
            // 获取行业列表
            getIndustryCategory () {
                api.industryCategory().then(res => {
                    if (res.ret === 0) {
                        this.industryList = []
                        let arr = res.data.map(({ name, code }) => {
                            return {
                                text: name,
                                value: code,
                                type: code
                            }
                        })
                        console.log(1231, arr)
                        let first = [{ text: '全部行业', type: '' }]
                        this.industryList.push([...first, ...arr])
                    }
                });
            },
            toPageDetailOrders (item) {
                this.$router.push({
                    path: 'workOrder',
                    query: { enterpriseId: item.workOrderId }
                });
            },
            handleTest () {
                this.examineDetailTips = false;
            },
            // 点击展开审查文本第一层
            handleSeeExamineText () {
                if (this.theExamineText === '') {
                    return ''
                } else {
                    this.isShowTheExamineText = !this.isShowTheExamineText;
                }
            },
            // 点击展开审查文本第二层
            handleClickAllExamineTex () {
                this.isShowAllExamineText = !this.isShowAllExamineText;
            },

            // 数据列表导航状态切换
            handleDlNavItemActive (index) {
                this.isDlNavItem = index;
                if (index === 0) {
                    this.finishedText = '没有更多了'
                } else {
                    this.finishedText = ''
                }
            },
            // 选择行业弹窗事件
            handleChoiceIndustryPop () {
                // this.isShowIndustryPop = true
                this.$refs.isShowIndustryPop.showPicker();
            },
            getTypeValue (data) {
                this.pageIndex = 1
                this.workOrderPageList = []
                this.industryText.text = data[0].text;
                this.industryCategory = data[0].type; // 行业参数
                this.getTaskProgress() // 饼状图
                this.getworkOrderPage()
            }
        },
        watch: {
            isShowTheExamineText: function (val) {
                this.listenTheMemo()
            }
        },
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            },
            filtTime1 (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D;
                return strDate;
            }
        }
    };
</script>
<style lang="less" scoped>
.wrapper{
  background: #fbfbfb;
}
.box {
  width: 100%;
  height: 100%;
  padding: 20px 12px 0 12px;
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #fbfbfb;

  .main {
    width: 100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;

    .statistics {
      width: 100%;
      padding: 12px 16px 16px 16px;
      box-sizing: border-box;

      .title {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
      }

      .completionDate {
        color: #999;
        font-size: 14px;
        margin-top: 8px;
      }

      .approvalStatus {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 12px;

        .mode {
          font-size: 14px;
          color: #ff8c19;
          line-height: 28px;
        }

        .mode2 {
          font-size: 14px;
          color: #36b374;
          line-height: 28px;
        }

        .mode3 {
          font-size: 14px;
          color: #ff4d4d;
          line-height: 28px;
        }

        .review {
          width: 64px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          font-size: 12px;
          background-color: #36b374;
          color: #fff;
          border-radius: 2px;
        }

        .seeTheExamineText::after {
          content: "";
          display: block;
          clear: both;
        }

        .seeTheExamineText {
          > span {
            font-size: 12px;
            font-weight: 400;
            color: #333;
            line-height: 12px;
            float: left;
          }

          .theExamineTextIcom {
            width: 12px;
            height: 12px;
            margin-left: 4px;
            float: left;

            > img {
              width: 100%;
              height: 100%;
              position: relative;
              top: 0px;
            }
          }
        }
      }

      .theExamineTextBox {
        // padding: 8px 12px 4px;
        background-color: #f8f8f8;
        border-radius: 3px;
        position: relative;
        &::after{
                position:absolute;
                top:-22px;
                right:20px;
                border-top:12px solid transparent;
                content:" "; // content 不要漏了，漏了会显示不出来
                width:0px;
                height:0px;
                border-right:12px solid transparent;
                border-bottom:12px solid rgba(248,248,248,1);
                border-left:12px solid transparent;
          }

        >#memoTextBox{
          padding: 8px 12px 4px;
          line-height: 20px;
          margin-top: 14px;

          .memoText{
            font-size: 12px;
            line-height: 20px;
          }
          > p.showSome{
            min-height: 76px;
            font-size: 12px;
            line-height: 20px;
            color: #666;
          }

          > p.showMore {
            font-size: 12px;
            height: 76px;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 20px;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
          }
        }

        .showAllExamineTextBtn::after {
          content: "";
          display: block;
          clear: both;
        }

        .showAllExamineTextBtn {
          padding-bottom: 5px;
          height: 26px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          text-align: center;
          line-height: 20px;
          color: #333;

          .showAllExamineTextIcon {
            width: 6px;
            height: 4px;
            margin-left: 4px;
            display: inline-block;
            position: relative;
            top: -2px;

            > img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .dataListBox {
      padding: 12px 16px 0px 16px;
      background-color: #fff;

      .dataListNav::after {
        content: "";
        display: block;
        clear: both;
      }

      .dataListNav {
        margin-bottom: 16px;

        .dataListNavItem {
          margin-right: 24px;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          line-height: 26px;
          color: #333;
          border-bottom: 2px solid transparent;
          float: left;
        }

        .dataListNavItem.active {
          color: #36b374;
          border-bottom-color: #36b374;
          padding-bottom: 2px;
          font-weight: 500;
        }
      }

      .choiceIndustryBox::after {
        content: "";
        display: block;
        clear: both;
      }

      .choiceIndustryBox {
        margin-bottom: 20px;
        padding: 8px 0 0;

        .choiceIndustryBtn::after {
          content: "";
          display: block;
          clear: both;
        }

        .choiceIndustryBtn {
          font-size: 14px;
          font-weight: bold;
          line-height: 14px;
          text-align: center;
          color: #333;
          float: left;

          .choiceIndustryBtnText {
            margin-right: 5px;
            float: left;
          }

          .choiceIndustryBtnIcon {
            width: 6px;
            height: 4px;
            float: left;
            position: relative;
            top: 5px;

            > img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .allListCounts {
          font-size: 12px;
          line-height: 14px;
          color: #999;
          float: right;
        }
      }

      .scoreObjectList {
        .scoreObjectListItem {
          margin-top: 22px;
          margin-bottom: 14px;

          .scoreObjectId {
            font-size: 12px;
            line-height: 20px;
            color: #999999;
          }

          .scoreObjectNameBox::after {
            content: "";
            display: block;
            clear: both;
          }

          .scoreObjectNameBox {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;

            .scoreObjectName {
              width: 210px;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #333;
              white-space: nowrap;
              float: left;
            }

            .scoreObjectTo::after {
              content: "";
              display: block;
              clear: both;
            }

            .scoreObjectTo {
              float: right;
              display:flex;
              align-items: center;

              > span {
                margin-right: 4px;
                line-height: 22px;
                color: #999;
                float: left;
              }
              > img {
                width: 100%;
                width: 12px;
                height: 12px;
                float: left;
                position: relative;
              }
            }
          }

          .scoreObjectBages::after {
            content: "";
            display: block;
            clear: both;
          }

          .scoreObjectBages {
            margin-top: 2px;
            padding: 4px 0;
            .locationBage {
              padding: 0px 2px 2px 2px;
              margin-right: 8px;
              font-size: 10px;
              line-height: 16px;
              height: 16px;
              color: #fff;
              color: rgba(34,131,230,1);
              float: left;
            }

            .industryBage {
              padding: 0px 2px 2px 2px;
              font-size: 10px;
              line-height: 16px;
              color: #36b374;
              float: left;
            }
          }
        }
        .scoreObjectListItemList{
          margin-bottom: 0;
        }
      }
      .wrapper{
        margin-top: 20px;
      }

      .taskDetailList {
        padding-bottom: 16px;
        .taskDetailListItem::after {
          content: "";
          display: block;

          clear: both;
        }

        .taskDetailListItem {
          padding: 4px 0;
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;
          // overflow: hidden;
          .taskDetailTitle {
            width: 96px;
            color: #999;
            float: left;
          }

          > p {
            margin-left: 96px;
          }
        }
      }

      .operationRecordList {
        .operationListItem:first-child {
          color: #333;

          .timePoint {
            border-color: #36b374;
          }
        }

        .operationListItem:last-child {
          border-color:#fff;
        }

        .operationListItem {
          margin-left: 8px;
          padding: 0 15px 24px 18px;
          color: #999;
          border-left: 1px solid #eaeaea;
          position: relative;

          .operationTitle {
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: bold;
          }
          .operationTime {
            margin-bottom: 8px;
            font-size: 12px;
          }
          .operaterBox {
            font-size: 12px;
            line-height:16px;
          }

          .operationDetail {
            font-size: 12px;
            line-height: 16px;
          }

          .timePoint {
            width: 14px;
            height: 14px;
            background-color: #fff;
            border: 1px solid #eaeaea;
            border-radius: 50%;
            position: absolute;
            top: -2px;
            left: -8px;
          }
        }
      }
    }

    .examinePicker {
      padding: 12px;

      .examinePickerTitle {
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
        line-height: 32x;
      }

      .examineBtns::after {
        content: "";
        display: block;
        clear: both;
      }

      .examineBtns {
        margin-bottom: 22px;

        > div {
          width: 64px;
          height: 28px;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          color: #36b374;
          border: 1px solid #36b374;
          border-radius: 2px;
          float: left;
        }

        > div.active {
          color: #fff;
          background-color: #36b374;
        }

        .throughExamine {
          margin-right: 12px;
        }
      }

      .examineMiddleBox {
        min-height: 75px;

        .examineOpinionBox {
          margin-bottom: 16px;
          font-size: 14px;
          color: #666;
        }

        .notThroughExamineTitile {
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          color: #333;

          > span {
            margin-left: 4px;
            font-size: 12px;
            font-weight: normal;
            color: #999;
          }
        }

        .throughExamineTextBox {
          margin-bottom: 24px;
          // height: 120px;

          .throughExamineText {
            height: 120px;
            padding: 16px;
            font-size: 14px;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
        }
      }

      .submitBtn {
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        background-color: #9bd9ba;
        border-radius: 3px;
      }

      .submitBtn.active {
        background-color: #36b374;
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }

    .examineDetailTipsBox {
      width: 120px;
      height: 124px;
      padding: 24px 0 0 0;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.7);
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      > img {
        width: 50px;
        height: 50px;
        margin: 0 auto 12px;
        display: block;
      }

      > p {
        text-align: center;
        color: #fff;
      }
    }
  }
}
</style>
